import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/index';
import './AttendeeCtrl.scss';
import { getIfShowAttendee, hideAttendee, showAttendee } from '@store/ui/ui.slice';
import { useAttendee } from '@utils/hooks/useUserList';

const AttendeeCtrl = () => {
  const dispatch = useAppDispatch();
  const ifShowAttendee = useAppSelector(getIfShowAttendee);
  const userList = useAttendee();

  const { t } = useTranslation();

  const toggleAttendee = () => {
    if (ifShowAttendee) {
      dispatch(hideAttendee());
    } else {
      dispatch(showAttendee());
    }
  };
  return (
    <div className="attendee-ctrl" onClick={toggleAttendee}>
      <div className="attendee-ctrl__icon" />
      <p>{t('成员({#userCount#})', { userCount: userList.length })}</p>
    </div>
  );
};

export default AttendeeCtrl;
